import React, { useState } from 'react';
import CustomAlert from '../components/CustomAlert';
import useCustomAlert from '../hooks/useCustomAlert';

const styles = `
.oficinas-page {
  min-height: 100vh;
  background-color: white;
}

.oficinas-hero {
  padding: 4rem 0 3rem;
  background: linear-gradient(to bottom, #f0f9f9, white);
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

.oficinas-title {
  font-size: 3rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 300;
  letter-spacing: 0.025em;
}

.oficinas-intro {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  color: #4A8080;
  line-height: 1.8;
  font-size: 1.125rem;
}

.oficinas-intro p {
  margin-bottom: 1rem;
}

.oficinas-highlight {
  font-weight: 600;
  color: #5A9C9C;
  font-size: 1.25rem;
  margin-top: 2rem;
}

.exploracao-section {
  padding: 5rem 0;
  background-color: #e0f2f2;
}

.section-title {
  font-size: 2.5rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 300;
}

.section-subtitle {
  text-align: center;
  color: #4A8080;
  max-width: 800px;
  margin: 0 auto 3rem;
  font-size: 1.125rem;
  line-height: 1.6;
}

.atividades-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.atividade-card {
  background-color: white;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.atividade-card:hover {
  transform: translateY(-5px);
}

.atividade-image {
  width: 100%;
  height: auto;
  min-height: 250px;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.atividade-image img {
  width: 100%;
  height: auto;
  object-fit: contain;
  max-height: 400px;
}

.atividade-card h3 {
  font-size: 1.5rem;
  color: #4A8080;
  padding: 1.5rem 1.5rem 1rem;
  margin: 0;
}

.atividade-card p {
  padding: 0 1.5rem 1.5rem;
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
}

.inscricao-section {
  padding: 5rem 0;
  background-color: white;
}

.inscricao-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1rem;
}

.inscricao-title {
  font-size: 2.5rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 300;
}

.inscricao-subtitle {
  text-align: center;
  color: #6b7280;
  margin-bottom: 3rem;
  font-size: 1.125rem;
}

.inscricao-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  color: #374151;
  font-size: 0.95rem;
  font-weight: 500;
}

.form-group input,
.form-group textarea {
  padding: 0.875rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #5A9C9C;
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.form-footer {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-top: 1rem;
}

.submit-btn {
  padding: 1rem 3rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background-color: #3A6666;
}

.form-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.form-info p {
  margin: 0;
  color: #6b7280;
  font-size: 0.875rem;
}

.info-section {
  padding: 4rem 0;
  background-color: #f9fafb;
}

.info-section .container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.info-box {
  background-color: white;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.info-box h3 {
  font-size: 1.5rem;
  color: #5A9C9C;
  margin-bottom: 1rem;
}

.info-box ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.info-box li {
  padding: 0.5rem 0;
  color: #4b5563;
  line-height: 1.6;
}

.info-box p {
  color: #4b5563;
  line-height: 1.6;
  margin: 0.5rem 0;
}

@media (max-width: 768px) {
  .oficinas-title {
    font-size: 2rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .inscricao-title {
    font-size: 2rem;
  }

  .atividades-grid {
    grid-template-columns: 1fr;
  }

  .form-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .submit-btn {
    width: 100%;
  }
}
`;

export default function OficinasVeraoPage() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    observacoes: ''
  });
  const { alertProps, showSuccess } = useCustomAlert();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Inscrição enviada:', formData);
    showSuccess('Inscrição enviada com sucesso! Entraremos em contacto em breve.');
  };

  return (
    <>
      <style>{styles}</style>
      <div className="oficinas-page">
      <section className="oficinas-hero">
        <div className="container">
          <h1 className="oficinas-title">Oficinas de Verão 2025</h1>
          <div className="oficinas-intro">
            <p>
              O Barco de Papel - Academia de Criatividade idealizou um programa super criativo e 
              com muita diversão para as Férias de Verão dos mais pequenos.
            </p>
            <p><strong>Dos 6 aos 12 anos</strong></p>
            <p>
              Teremos entre outros, Oficinas de Artes, Jogos, Brincadeiras com muita diversão e 
              aprendizagem junta.
            </p>
            <p>Uma excelente notícia para os mais pequenos e para os pais!</p>
            <p className="oficinas-highlight">Veja o programa completo!</p>
          </div>
        </div>
      </section>

      <section className="exploracao-section">
        <div className="container">
          <h2 className="section-title">Exploração Criativa</h2>
          <p className="section-subtitle">
            Descubra atividades envolventes e educativas para as Férias de Verão, promovendo a 
            imaginação e a diversão das crianças.
          </p>

          <div className="atividades-grid">
            <div className="atividade-card">
              <div className="atividade-image">
                <img src="/assets/image8.png" alt="Oficinas de Verão 2025" />
              </div>
              <h3>Arte Divertida</h3>
              <p>
                Explora a expressão artística das crianças através de atividades de pintura, 
                colagem e modelagem, estimulando a criatividade.
              </p>
            </div>

            <div className="atividade-card">
              <div className="atividade-image">
                <img src="/assets/image9.png" alt="Programa Julho 25" />
              </div>
              <h3>Aprendizagem Ativa</h3>
              <p>
                Proporcionamos um ambiente estimulante para que as crianças aprendam de forma 
                interativa e dinâmica, desenvolvendo novas habilidades.
              </p>
            </div>

            <div className="atividade-card">
              <div className="atividade-image">
                <img src="/assets/image10.png" alt="Programa Agosto 25" />
              </div>
              <h3>Jogos Educativos</h3>
              <p>
                Incentivamos a aprendizagem através de jogos educativos que desafiam as crianças 
                a pensar de forma crítica e colaborativa.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="inscricao-section">
        <div className="inscricao-container">
          <h2 className="inscricao-title">Inscrição para o Verão</h2>
          <p className="inscricao-subtitle">
            Descubra atividades criativas para as Férias de Verão da Academia Barco de Papel.
          </p>

          <form className="inscricao-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="nome">Digite seu nome completo *</label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="telefone">Telefone</label>
              <input
                type="tel"
                id="telefone"
                name="telefone"
                placeholder="Telefone"
                value={formData.telefone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="observacoes">Observações</label>
              <textarea
                id="observacoes"
                name="observacoes"
                placeholder="Preencha com os dias pretendidos"
                rows="5"
                value={formData.observacoes}
                onChange={handleChange}
              />
            </div>

            <div className="form-footer">
              <button type="submit" className="submit-btn">
                Enviar Inscrição
              </button>
              <div className="form-info">
                <p>Vagas Limitadas</p>
                <p>Pagamento antecipado</p>
              </div>
            </div>
          </form>
        </div>
      </section>

      <section className="info-section">
        <div className="container">
          <div className="info-box">
            <h3>Informações Importantes</h3>
            <ul>
              <li><strong>Datas:</strong> 1 de Julho a 31 de Agosto de 2025</li>
              <li><strong>Idades:</strong> Dos 6 aos 12 anos</li>
              <li><strong>Horário:</strong> Das 9h às 17h30</li>
              <li><strong>Local:</strong> R. 31 janeiro, 12 - 4490-511 Póvoa de Varzim</li>
              <li><strong>Inclui:</strong> Almoço e lanches</li>
            </ul>
          </div>

          <div className="info-box">
            <h3>Contactos</h3>
            <p>
              <strong>Email:</strong> academiabarcodepapel@gmail.com<br />
              <strong>Telefone:</strong> 936 678 220
            </p>
            <p>Para mais informações, não hesite em contactar-nos!</p>
          </div>
        </div>
      </section>
      <CustomAlert {...alertProps} />
      </div>
    </>
  );
}